<script lang="ts" setup>
import { ConsultationSourceEnum } from '@forgd/contract/types'
import type { ConsultationSourceEnumType } from '@forgd/contract/types'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'

withDefaults(defineProps<{
  source?: ConsultationSourceEnumType
}>(), {
  source: ConsultationSourceEnum.NavSidebar,
})

const { destination } = useConsultationDestination()
const { captureConsultationClick } = useConsultationTracking()
</script>

<template>
  <NuxtLink
    data-el="CoreConsultationCard"
    :to="destination.to"
    :external="destination.external"
    :target="destination.target"
    :rel="destination.external ? 'noopener noreferrer' : undefined"
    class="flex items-start gap-2 rounded-md border border-[rgba(44,59,82,0.7)] bg-brand-900 p-2 transition-opacity hover:opacity-90"
    @click="captureConsultationClick(source, destination.to)"
  >
    <video
      src="/images/advisory/talk-to-experts.mp4"
      autoplay
      loop
      muted
      playsinline
      aria-hidden="true"
      class="h-10.5 shrink-0 rounded object-cover"
    />
    <div class="flex flex-col">
      <span class="text-sm font-normal leading-normal text-secondary-inverted">Talk to our experts for free</span>
      <span class="flex items-center gap-1 text-sm font-normal leading-normal text-primal-inverted">
        Book a Consultation
        <ArrowRightIcon class="size-3.5" />
      </span>
    </div>
  </NuxtLink>
</template>
